<template>
    <div id="app" class="gastro-app__content" :class="{'is-loading': waiting}" :style="appStyle">
        <template v-if="loadedData">
            <template v-if="!selectedBeer">
                <div class="gastro-app__header">
                    <i class="icon-left-arrow" v-if="selectedCategory !== null" @click="selectedCategoryId = null; searchVal = ''"></i>
                    <h1>{{categoryName}}</h1>
                </div>
                <search :s.sync="searchVal" @onReset="searchVal = ''" :placeholder="selectedCategoryId !== null ? this.selectedCategory.search : null"/>

                <template v-if="selectedCategoryId === null && ( searchVal === '' ||  searchVal.length <= 1)">
                    <categories-list :data="data.categories" @onSelectCategory="selectCategory" />
                </template>

                <template v-else>
                    <meals-list :data="meals" @onSelectMeal="selectMeal" v-if="meals.length > 0"/>
                    <div class="no-result" v-else>
                        <p v-html="translate('no_results')"></p>
                        <h3 v-html="translate('no_results_content')"></h3>
                        <button type="button" class="btn" @click="addMeal"><span v-text="translate('no_results_cta')"></span></button>
                    </div>
                </template>
            </template>
            <beer-page v-else :beers="data.beers" :beer-id="selectedBeer" :meal="selectedMeal" @onClose="closeBeerPage" @onAdditivesChange="openPopup"/>

            <div class="popup" v-show="showPopup" :style="popupStyle">
                <meal-popup :meal="selectedMeal" :additives="data.additives" @onClose="closePopup" @onSuggestBeer="showBeerPage" v-if="selectedMealId !== null"/>
                <form-popup @onClose="closePopup"  v-if="formPopup"/>
            </div>
        </template>
    </div>
</template>

<script>

// import {meals, categories, beers, additives} from "./test-data";
import Search from "./components/Search";
import CategoriesList from "./components/CategoriesList";
import MealsList from "./components/MealsList";
import BeerPage from "./components/BeerPage";
import MealPopup from "./components/MealPopup";
import FormPopup from "./components/FormPopup";
import {translate} from "@/helpers/helpers";

export default {
    name: 'App',
    components: {
        FormPopup,
        MealPopup,
        BeerPage,
        MealsList,
        CategoriesList,
        Search
    },
    data() {
        return {
            loadedData: false,
            iframeInfo: false,
            waiting: true,
            data: {},
            selectedCategoryId: null,
            selectedMealId: null,
            selectedBeer: null,
            selectedMealFullName: '',
            searchVal: '',
            showPopup: false,
            formPopup: false,
            popupStyle: {
                top: "0px",
                left: "0px",
                width: "100%",
                height: "100%"
            },
            appStyle: {
                minHeight: "0px"
            }
        };
    },
    computed: {
        selectedCategory() {
            if(this.selectedCategoryId !== null) {
                let cat = this.data.categories.find(obj => obj.id === this.selectedCategoryId )
                if(typeof cat === "object") {
                    return cat;
                }
                return null;
            }
            return null;
        },
        categoryName() {
            return this.selectedCategory !== null ? this.selectedCategory.name : this.translate('select_category');
        },
        meals() {
            if(this.data.meals) {
                let data = this.data.meals;
                if(this.selectedCategory !== null) {
                    data = data.filter((item) => item.cat === this.selectedCategory.id)
                }
                if(this.searchVal !== '' && this.searchVal.length > 1) {
                    data = data.filter((item) => item.name.toLowerCase().indexOf(this.searchVal.toLowerCase()) >= 0)
                }
                return data;
            }else{
                return [];
            }
        },
        selectedMeal() {
            if(this.selectedMealId === null) return {};
            else return {
                fullName: this.selectedMealFullName,
                ...this.meals.find(obj => obj['id'] === this.selectedMealId )
            };
        }
    },
    created () {
        this.checkParentHeight();
        this.fetchData();
    },
    methods: {
        translate: translate,
        checkParentHeight() {
            if ('parentIFrame' in window) {
                if (!this.iframeInfo) {
                    this.iframeInfo = true;
                    parentIFrame.getPageInfo(
                        (pageInfo) => {
                            let top = pageInfo.scrollTop - pageInfo.offsetTop;
                            let height = pageInfo.clientHeight;
                            let minHeight = height;
                            let width = pageInfo.clientWidth;

                            // window height
                            if(width < 992) {
                                minHeight -= 113;
                            }else {
                                minHeight -= 153;
                            }
                            this.appStyle.minHeight = minHeight + "px";

                            // popup
                            if(top<0) {
                                let diff = Math.abs(top);
                                top = 0;
                                height -= diff;
                            }
                            this.popupStyle.top = top + "px";
                            this.popupStyle.height = height + "px";
                        }
                    );
                }
            }
        },
        fetchTestData() {
            this.waiting = true;

            setTimeout(()=>{

                this.data.meals = Array.from(meals);
                this.data.categories = Array.from(categories);
                this.data.additives = Array.from(additives);
                this.data.beers = Object.assign({}, beers);

                this.waiting = false;
                this.loadedData = true;
            }, 400);

        },
        selectCategory(cat) {
            this.waiting = true;
            this.selectedCategoryId = cat;


            setTimeout(()=>{
                this.waiting = false;
            }, 250);
        },
        selectMeal(id) {
            this.selectedMealId = id;

            if(this.selectedMeal.additives !== null && (this.selectedMeal.additives.length > 0 || this.selectedMeal.souce.length > 0)) {
                this.openPopup();
            }else{
                this.showBeerPage(this.selectedMeal.beer, '');
            }
        },
        closePopup() {
            if(this.selectedBeer) {
                this.showPopup = false;
            }else{
                this.selectedMealId = null;
                this.showPopup = false;
                this.formPopup = false;
            }
            if ('parentIFrame' in window) {
                parentIFrame.sendMessage('closePopup');
            }
        },
        showBeerPage(beer, mealName) {
            this.waiting = true;
            this.showPopup = false;

            this.selectedBeer = beer;
            this.selectedMealFullName = mealName;

            this.waiting = false;

            this.closePopup();


        },
        closeBeerPage() {
            this.selectedBeer = null;
            this.selectedMealId = null;
        },
        addMeal() {
            this.openPopup();
            this.formPopup = true;

        },
        fetchData() {
            this.waiting = true;

            this.axios.get(`api/${(this.$route.meta.lang || 'pl')}`, {})
                .then(result => {
                    this.data = result.data;

                    this.waiting = false;
                    this.loadedData = true;

                    this.checkParentHeight();
                }).catch((e) => {
            });
        },
        openPopup() {
            if ('parentIFrame' in window) {
                parentIFrame.sendMessage('openPopup');
            }

            this.showPopup = true;
        },
    }
}
</script>

<style>
</style>
